import React, { Component } from 'react';
import { Text, ViewBox } from './../common';
import styled from 'styled-components';
import { Flex, Box } from 'rebass';
import { colors } from '../../tailwind';
import history from '../../core/history';
import moment from 'moment';
import { buildAvatarPath } from '../../helpers/photoutils';
import Link from '../../components/Link';

export default class NewMessages extends Component {
  buildMessageJSX(message, idx, totalMessages) {
    const {
      listId,
      hostId,
      guestId,
      displayName,
      picture,
      title,
      createdAt,
      threadId,
      inboxType,
      reservationRange,
      total,
    } = message;

    const ellapsedTime = moment(createdAt).fromNow();

    return (
      <Flex
        key={threadId || listId + hostId + guestId}
        justifyContent="space-between"
        py="24px"
        flexWrap="wrap"
        className="hover-list-hover pointer"
        style={{
          borderBottom:
            idx < totalMessages - 1
              ? `solid 0.5px ${colors.coolGrayLight}`
              : null,
        }}
      >
        <Flex alignItems="center">
          <AvatarImage src={buildAvatarPath(picture)} />
          <Flex
            flexWrap="wrap"
            justifyContent="space-between"
            mx={1}
            onClick={() => history.push(`/inbox/${threadId}`)}
          >
            <Flex alignItems="center" justifyContent="space-between">
              <Text pl={3} clickable>
                <Text bold inline clickable>
                  {displayName}
                </Text>
                {inboxType === 'MESSAGE'
                  ? ' has a question about your '
                  : ' requested to rent your '}
                <Text link inline clickable>
                  {title}
                </Text>
              </Text>
            </Flex>
            <Flex alignItems="center" pl={4} style={{ minWidth: 161 }}>
              {inboxType === 'RESERVATION' ? (
                <Text clickable>
                  {reservationRange}{' '}
                  <Text inline pl={3} clickable>
                    -
                  </Text>
                  <Text bold inline pl={3} clickable>
                    ${total}
                  </Text>
                </Text>
              ) : null}
            </Flex>
          </Flex>
        </Flex>
        <Flex alignItems="center">
          <Text clickable>{ellapsedTime}</Text>
        </Flex>
      </Flex>
    );
  }

  buildInbox(messages, reservations, userId) {
    const messages2 = messages
      ? messages
          .filter(x => x.threadItemUnread.sentBy === userId)
          .map(message => ({
            listId: message.listId,
            hostId: message.hostId,
            guestId: message.guestId,
            displayName: message.guestProfile.displayName,
            picture: message.guestProfile.picture,
            title: message.listData.title,
            threadId: message.threadItemUnread.threadId,
            createdAt: new Date(message.threadItemUnread.createdAt),
            inboxType: 'MESSAGE',
          }))
      : [];
    const reservations2 = reservations
      ? reservations
          .filter(
            x =>
              !x.resevationState === 'completed' &&
              (x.reservationState === 'pending' && x.guestId !== userId) &&
              (x.reservationState === 'approved' && x.hostId !== userId) &&
              (x.reservationState === 'declined' && x.hostId !== userId),
          )
          .map(reservation => {
            const startMonth = moment(reservation.checkIn).format('MMM');
            const startDay = moment(reservation.checkIn).format('D');
            const endMonth = moment(reservation.checkOut).format('MMM');
            const endDay = moment(reservation.checkOut).format('D');
            const range =
              startMonth === endMonth
                ? `${startMonth} ${startDay} - ${endDay}`
                : `${startMonth} ${startDay} - ${endMonth} ${endDay}`;
            return {
              listId: reservation.listId,
              hostId: reservation.hostId,
              guestId: reservation.guestId,
              displayName: reservation.guestData.displayName,
              picture: reservation.guestData.picture,
              title: reservation.listData.title,
              createdAt: new Date(reservation.createdAt),
              inboxType: 'RESERVATION',
              checkIn: reservation.checkIn,
              checkOut: reservation.checkOut,
              reservationRange: range,
              total: reservation.total,
              threadId: reservation.messageData
                ? reservation.messageData.id
                : null,
            };
          })
      : [];

    const newArr = [...messages2, ...reservations2].sort((a, b) => {
      const key1 = a.createdAt;
      const key2 = b.createdAt;

      if (key1 < key2) {
        return 1;
      } else if (key1 == key2) {
        return 0;
      }
      return -1;
    });
    return newArr;
  }

  render() {
    const { messages, reservations, loading, userId } = this.props;
    const msgs = messages && this.buildInbox(messages, reservations, userId);
    const messageCount = (msgs && msgs.length) || 0;
    return (
      <ViewBox
        header={`Notifications (${messageCount})`}
        loading={loading}
        justifyContent={!messages ? 'center' : null}
        alignItems={!messages ? 'center' : null}
        style={{ width: '100%', maxWidth: '1000px' }}
      >
        {!msgs || !msgs.length ? (
          <Flex height="100%">
            <Text large>No messages found.</Text>
          </Flex>
        ) : (
          msgs
            .slice(0, 3)
            .map((message, idx) =>
              this.buildMessageJSX(message, idx, messageCount),
            )
        )}
        {messageCount > 3 && (
          <Link to="/inbox">
            <Text link pt="24px">
              See all messages
            </Text>
          </Link>
        )}
      </ViewBox>
    );
  }
}

const AvatarImage = styled.img`
  width: 48px;
  height: 48px;
  border: solid 1.5px ${colors.primaryDark};
  border-radius: 50%;
  object-fit: cover;
`;



// WEBPACK FOOTER //
// ./src/components_new/dashboard/NewMessages.js